import React from 'react';
import useUser from '../UserProvider/useUser';
import {Route, Redirect} from 'react-router-dom';

export const withCompatPrivateRoute = (WrappedComponent, resource) => {
    return function CompatPrivateRouteWrapper(props) {
        const { can } = useUser()
        if (!can('READ', resource)) return null
        return <WrappedComponent {...props} />
    }
}


const PrivateRoute = ({ children, resource, ...rest }) => {
    const {can, landingRoute} = useUser();

    return(
        <Route
            {...rest}
            render={({location}) =>
                (resource && can('READ', resource)) ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: landingRoute(),
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    )
}

export default PrivateRoute;
